import { Box } from '@mui/material';
import { LabelBadge } from '../../../../../shared/components/common/labelBadge';

const statusColorMap = {
	InComplete: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	Pending: { bg: '#ffffff', text: '#063236', outlineClass: 'outline outline-blue-300' },
	Approved: { bg: '#00D175', text: '#063236' },
	Archived: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
};

const initialsOf = (businessName, firstName, lastName) => {
	const source = businessName || `${firstName || ''} ${lastName || ''}`.trim();
	const parts = source.split(' ').filter(Boolean);
	if (!parts.length) return '?';
	return parts.length === 1 ? parts[0].slice(0, 2).toUpperCase() : (parts[0][0] + parts[1][0]).toUpperCase();
};

export const InitializeInvestorBorrowersColumns = (t) => {
	return [
		{
			header: t('businessName'),
			accessorKey: 'businessName',
			size: 220,
			Cell: ({ cell, row }) => {
				const { businessName, firstName, lastName, nationalId } = row.original;
				return (
					<Box className="flex items-center gap-2">
						<Box className="w-8 h-8 rounded-full bg-investor-mint/40 text-investor-deep font-bold text-xs flex items-center justify-center flex-shrink-0">
							{initialsOf(businessName, firstName, lastName)}
						</Box>
						<Box className="flex flex-col">
							<span className="font-bold">{businessName || `${firstName || ''} ${lastName || ''}`.trim()}</span>
							{nationalId ? <span className="text-[11px] text-investor-slate">{nationalId}</span> : null}
						</Box>
					</Box>
				);
			},
		},
		{
			header: t('crNumber'),
			accessorKey: 'crNumber',
			size: 140,
		},
		{
			header: t('sector'),
			accessorKey: 'sector',
			size: 140,
		},
		{
			header: t('loans'),
			accessorKey: 'loansCount',
			size: 80,
		},
		{
			header: t('status'),
			accessorKey: 'status',
			Cell: ({ cell }) => {
				const raw = cell?.getValue();
				const colors = statusColorMap[raw] ?? { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' };
				return (
					<LabelBadge
						label={raw}
						bgColor={colors.bg}
						textColor={colors.text}
						classList={`!inline-flex !w-[90px] !rounded-full !px-2 !py-1 !text-[11px] !font-bold !normal-case !whitespace-nowrap ${colors.outlineClass ?? ''}`}
					/>
				);
			},
			size: 100,
		},
	];
};
